export const RENTAL_PAYMENT_FREQUENCIES = [
  "Mensal",
  "Bimestral",
  "Trimestral",
  "Semestral",
  "Anual",
] as const;

export const RENTAL_GUARANTEE_TYPES = [
  "Deposito_Caucao",
  "Seguro_Fianca",
  "Fiador",
] as const;

export const RENTAL_INCLUDED_EXPENSES = [
  "Agua",
  "Luz",
  "Gas",
  "IPTU",
  "Internet",
  "TV_a_cabo",
] as const;

export const ADMINISTRATION_TYPES = [
  "Imobiliaria",
  "Particular",
] as const;

export type RentalPaymentFrequency = (typeof RENTAL_PAYMENT_FREQUENCIES)[number];
export type RentalGuaranteeType = (typeof RENTAL_GUARANTEE_TYPES)[number];
export type RentalIncludedExpense = (typeof RENTAL_INCLUDED_EXPENSES)[number];
export type AdministrationType = (typeof ADMINISTRATION_TYPES)[number];
